import { FC } from 'react';
import { TypeYotpoBrandReviewsFields } from '@/core/generated-types';
import styles from '@/components/ui/YotpoReviewStars/YotpoReviewStars.module.scss';
import classNames from 'classnames';

export const YotpoBrandReviews: FC<TypeYotpoBrandReviewsFields> = ({
  entryName,
  maxWidth,
}) => {
  /*
    The Yotpo script loading and subsequent DOM update take place
    in a custom hook called in the parent layout component.
  */

  return (
    <div
      id="yotpo-testimonials-custom-tab"
      className={classNames(styles.root, 'mx-auto')}
      style={{ maxWidth }}
      data-testid={`yotpo-brand-reviews-${entryName}`}
    />
  );
};
